/**
 * communication from main window to preview iframe
 * */
import { useActions } from "@/store/vuex-composition-mappers";
import { PageProject } from "@/apps/page/page-project.interface";
import { createActionPayload } from "@/views/tools/page/utils/create-action-payload";

// enum for preview actions
export const PREVIEW_ACTIONS = {
    reloadPageData: "reloadPageData",
    scrollToSection: "scrollToSection",
};

export function usePreviewActions() {
    // @ts-expect-error
    const { sendDataToIFrame } = useActions("page", ["sendDataToIFrame"]);

    return {
        [PREVIEW_ACTIONS.scrollToSection](webId?: string) {
            sendDataToIFrame(createActionPayload(PREVIEW_ACTIONS.scrollToSection, { webId }));
        },
        // new way to fire refreshIframe action to reload page data inside iframe preview:
        [PREVIEW_ACTIONS.reloadPageData](data: PageProject) {
            sendDataToIFrame(createActionPayload(PREVIEW_ACTIONS.reloadPageData, { data }));
        },
    };
}
